import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-currency-cell',
  templateUrl: './currency-cell.component.html',
  styleUrl: './currency-cell.component.scss'
})
export class CurrencyCellComponent {
  @Input() amount?: string;
  @Input() currency?: string;
  @Input() compensationType?: 'DAY' | 'HOUR' | null;

  get unitLabel(): string {
    return this.compensationType === 'HOUR' ? 'Par heure' : 'Par jour';
  }
}
